var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpeechtopiaPen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h4V46h-4v-2.7L49.1 30 32-1 14.9 30 22 43.3V46h-4v12h4v6h20v-6zM32 25.9a3 3 0 110 6 3 3 0 010-6zM17.1 30L31 5v19a5 5 0 00-4 5 5 5 0 0010 0 5 5 0 00-4-5V5L46.9 30 40 42.7V46H24v-3.3L17.1 30zM20 56v-8h24v8H20zm20 6H24v-4h16v4z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeechtopiaPen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/speechtopia-pen.8068f246.svg";
export { ForwardRef as ReactComponent };